import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

import { getSettings } from 'utils/settings';

function Logo({ style, variant }) {
  const companyLogo = getSettings(`logo.${variant}`);
  const companyName = getSettings('company.name', '');

  // Fallback white-label: si la config del dominio no trae logo,
  // se muestra el nombre de la marca en lugar de una imagen rota.
  if (!companyLogo) {
    if (!companyName) {
      return null;
    }

    return (
      <Typography
        component="span"
        style={{
          fontSize: 26,
          fontWeight: 700,
          letterSpacing: '-0.02em',
          ...style,
        }}
      >
        {companyName}
      </Typography>
    );
  }

  return (<img
    alt={companyName || 'Company logo'}
    src={companyLogo}
    style={style}
  />);
}

Logo.defaultProps = {
  company: 'a55',
  variant: 'imagotipo-horizontal-dark',
};

Logo.propTypes = {
  style: PropTypes.object,
  variant: PropTypes.oneOf([
    'imagotipo',
    'imagotipo-horizontal',
    'imagotipo-horizontal-dark',
  ]),
};

export default Logo;
